<template>
  <div>
    <div class="container-fluid" id="invoice-pdf" :style="{background: linear_gradient, 'background-color': customBg}">
      <div class="row">
        <div class="col text-center">
          <md-button @click="goBack"><span id="skip-button">Skip</span></md-button>
        </div>

        <div class="col text-center">
          <md-button @click="submitPersonalizeInvoice">Done</md-button>
        </div>
      </div>

      <img src="@/assets/images/ic_preview.svg" v-if="style_1">
      <img src="@/assets/images/ic_preview2.svg" v-if="style_2">
      <img src="@/assets/images/ic_preview3.svg" v-if="style_3">

      <label v-if="current_tab == 'tab-color'">NOTED: Your colour will be used when creating a new invoice</label>
    </div>
    <md-tabs id="personalization-tabs" class="md-transparent" md-alignment="fixed" @md-changed="tabChanged">
      <!-- Invoice Style -->
      <md-tab id="tab-style" md-label="Style">
        <div class="tab-content">
          <div class="row" style="padding: 8px;">
            <div class="col">
              <div class="invoice-style-container">
                <img src="@/assets/images/style1.svg" class="img-fluid invoice-style" @click="select_style_1">
                <img src="@/assets/images/tick-mark.svg" class="tick-mark" v-if="style_1">
              </div>
            </div>
            <div class="col">
              <div class="invoice-style-container">
                <img src="@/assets/images/style2.svg" class="img-fluid invoice-style" @click="select_style_2">
                <img src="@/assets/images/tick-mark.svg" class="tick-mark" v-if="style_2">
              </div>
            </div>
            <div class="col">
              <div class="invoice-style-container">
                <img src="@/assets/images/style3.svg" class="img-fluid invoice-style" @click="select_style_3">
                <img src="@/assets/images/tick-mark.svg" class="tick-mark" v-if="style_3">
              </div>
            </div>
          </div>
        </div>
      </md-tab>

      <!-- Invoice Logo -->
      <!--<md-tab id="tab-logo" md-label="Logo">-->
      <!--<div class="tab-content">-->
      <!--<div v-if="!logo_image">-->
      <!--<p class="text-center" style="padding-top:15px;">-->
      <!--Upload a logo for your business-->
      <!--</p>-->
      <!--<div class="custom-file">-->
      <!--<b-form-file-->
      <!--accept="image/*"-->
      <!--type="file"-->
      <!--class="custom-file-input"-->
      <!--@change="onFileChange"-->
      <!--&gt;</b-form-file>-->
      <!--<button class="btn upload-logo-button">Upload</button>-->
      <!--</div>-->
      <!--</div>-->

      <!--<div v-if="logo_image">-->
      <!--<img :src="logo_image" class="img-fluid" id="uploaded-logo">-->
      <!--<div class="row">-->
      <!--<div class="col text-center">-->
      <!--<button class="btn remove-logo-button" @click="removeImage">Remove</button>-->
      <!--</div>-->

      <!--<div class="col">-->
      <!--<div class="custom-file change-file">-->
      <!--<b-form-file-->
      <!--accept="image/*"-->
      <!--type="file"-->
      <!--class="custom-file-input"-->
      <!--@change="onFileChange"-->
      <!--&gt;</b-form-file>-->
      <!--<button class="btn upload-logo-button">Change</button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</md-tab>-->

      <!-- Invoice Color -->
      <md-tab id="tab-color" md-label="Color">
        <div class="tab-content">
          <div class="colors table-responsible">
            <table>
              <tbody>
              <tr>
                <td
                        v-for="color in filteredColors1"
                        :style="{ 'background-color': color }"
                        :key="color"
                        @click="select_color_row_1(color)"
                >
                  <img src="@/assets/images/tick-mark.svg" class="color-tick-mark" v-if="selected_color == color">
                  <img src="@/assets/images/ic_edit.svg" class="color-edit-mark" v-if="color == '#FFFFFF'">
                </td>
              </tr>
              <tr>
                <td
                        v-for="color in filteredColors2"
                        :style="{ 'background-color': color}"
                        :key="color"
                        @click="select_color_row_1(color)"
                >
                  <img src="@/assets/images/tick-mark.svg" class="color-tick-mark" v-if="selected_color == color">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </md-tab>
    </md-tabs>

    <vapp-alertview v-if="is_show_overlay" :viewPersonalization="true"></vapp-alertview>
  </div>
</template>

<script>
export default {
  name: 'InvoicePersonalization',
  data() {
    return {
      style_1: false,
      style_2: false,
      style_3: false,
      logo_image: '',
      linear_gradient: 'linear-gradient(to bottom, #01978a, #037582)',
      customBg: null,
      isActive: false,
      colors: [
        '#FFFFFF',
        '#E91F63',
        '#673BB8',
        '#2296F3',
        '#01BCD5',
        '#F1C40F',
        '#E67E22',
        '#2ECC71',
        '#ECF0F1',
        '#F44236',
        '#9C28B1',
        '#3F51B5',
        '#04A9F5',
        '#019688',
        '#F39C12',
        '#9B59B6',
        '#E91F62',
        '#000000'
      ],
      selected_color: '',
      selected_style: 0,
      current_tab: null,
      isRegister: false,
      is_show_overlay: false,
    }
  },
  created() {
    this.$root.$on('proceed-personalize', vars => {
      this.is_show_overlay = false;
    });
    this.$root.$on('skip-personalization', vars => {
      this.is_show_overlay = false;
      this.$router.push('/')
    });
  },
  methods: {
    select_style_1() {
      this.style_1 = true
      this.style_2 = false
      this.style_3 = false
      this.selected_style = 0
    },
    select_style_2() {
      this.style_2 = true
      this.style_1 = false
      this.style_3 = false
      this.selected_style = 1
    },
    select_style_3() {
      this.style_3 = true
      this.style_1 = false
      this.style_2 = false
      this.selected_style = 2
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if(!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage(file) {
      var image = new Image()
      var reader = new FileReader()
      var vm = this

      reader.onload = (e) => {
        vm.logo_image = e.target.result
      }

      reader.readAsDataURL(file)
    },
    removeImage: function(e) {
      this.logo_image = ''
    },
    select_color_row_1(color) {
      this.selected_color = color
    },
    goBack() {
      if (this.isRegister) {
        this.$router.push('/')
      } else {
        this.$router.go(-1)
      }
    },
    submitPersonalizeInvoice() {
      //Updated template
      this.$root.$emit('show-loading', true);

      if(this.selected_color == '#FFFFFF') {
        this.selected_color = ''
      }

      this.axios({
        method: 'put',
        url: '/setting/update_template',
        data: {
          'company_id': this.$store.state.selected_company,
          'txn_template': this.selected_style,
          'txn_template_color' : this.selected_color,
        }
      }).then(response => {
        this.$root.$emit('show-loading', false);
        console.log('update template: ', response.data)

        if (this.isRegister) {
          this.$router.push('/')
        } else {
          this.$router.go(-1)
        }
      }).catch(error => {
        this.$root.$emit('show-loading', false);
      this.$generalAPIErrorHandling(error, this.$router);
      })
    },
    tabChanged: function(id) {
      this.current_tab = id
    },
  },
  mounted() {
    console.log('Invoice object: ', this.$store.state.invoice_obj)

    // From registration screen?
    this.isRegister = this.$route.params.isRegister;

    if (this.isRegister) {
      this.is_show_overlay = true;
    }

    //Get active template
    this.$root.$emit('show-loading', true);

    this.axios({
      method: 'get',
      url: '/setting/active_template?',
      params: {
        'business_id': this.$store.state.selected_company
      }
    }).then(response => {
      this.$root.$emit('show-loading', false);

    console.log('active template: ', response.data)

      if (response.data.template.txn_template == 0) {
        this.style_1 = true
        this.style_2 = false
        this.style_3 = false
        this.selected_style = 0
      } else if (response.data.template.txn_template == 1)  {
        this.style_1 = false
        this.style_2 = true
        this.style_3 = false
        this.selected_style = 1
      } else {
        this.style_1 = false
        this.style_2 = false
        this.style_3 = true
        this.selected_style = 2
      }

      this.selected_color = response.data.template.txn_template_color

    }).catch(error => {
      this.$root.$emit('show-loading', false);
    this.$generalAPIErrorHandling(error, this.$router);
    })
  },
  computed: {
    filteredColors1: function () {
      return this.colors.slice(0, 9)
    },
    filteredColors2: function () {
      return this.colors.slice(9, 18)
    }
  }
}
</script>

<style lang="scss">
$screen-sm-min: 375px;

@mixin sm {
  @media (min-width: #{$screen-sm-min}) {
    @content;
  }
}

#invoice-pdf {
    position: relative;
    height: calc(100vh - 125px);
    transition: background-color 0.2s ease-in-out;
    // background: linear-gradient(to bottom, #11998e, #16a58c);

    button {
      color: white;
    }

    img {
      position: absolute;
      top: 47%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding-bottom: 15px;
      width: 75%;
    }

  label {
    position: absolute;
    bottom: 60px;
    color: white;
    text-align: center;
    font-size: 12px;
  }
}

#personalization-tabs {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}

#skip-button {
  opacity: 0.6;
}

.md-tabs.md-alignment-fixed .md-tabs-navigation .md-button {
  opacity: 1 !important;
  background-color: transparent !important;
  color: #b3b5b9 !important;
}

.md-tabs.md-alignment-fixed .md-tabs-navigation .md-button.md-active {
  background-color: transparent !important;
  opacity: 1 !important;
  border-bottom: 8px solid #06d2c5;
  color: white !important;
}

.md-tab {
  padding: 0 !important;

  .tab-content {
    height: 125px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #f1f3f2;
  }

  @include sm {
    .tab-content {
      height: 150px;
    }
  }
}

.invoice-style-container {
  position: relative;

  .invoice-style {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .tick-mark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: fade-in 0.2s ease-in-out;
    animation-fill-mode: forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}

#uploaded-logo {
  display: block;
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
  max-width: 125px;
}

.upload-logo-button {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #047382;
  color: white;
  border-radius: 10px;
}

.remove-logo-button {
  background-color: transparent;
  border: 2px solid #047382 !important;
  color: #047382;
}

.colors {
  overflow: hidden;

  table {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
    border-collapse: collapse;
    overflow: hidden;
    /* Use this to create a "dead" area color if table is too wide for cells */
    background-color: #ccc;
  }

  /* Scroll the actual tbody (second child on all browsers) */
  tbody {
    display: block;
    overflow: scroll;
  }

  /* IE11 adds an extra tbody, have to hide it */
  tbody:nth-child(3) { display: none; }

  /* The one caveat, a hard-set width is required. */
  td {
    width: 72px;
    height: 72px;
    min-width: 72px;
    padding: 0.3em;
    border: 1px solid white;
  }

  .color-tick-mark {
    height: 20px;
    width: 20px;
    animation: color-fade-in 0.2s ease-in-out;
    animation-fill-mode: forwards;
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .color-edit-mark {
    height: 20px;
    width: 20px;
    animation: color-fade-in 0.2s ease-in-out;
    animation-fill-mode: forwards;
    position: absolute;
    bottom: 5px;
    left: 5px;
  }

  td {
    position: relative;
  }

  @keyframes color-fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
}


</style>
